import { isProd } from "@/src/helpers/environment";

export const ALGOLIA_APPLICATION_ID = "2PJRXP9XOP";
export const ALGOLIA_SEARCH_API_KEY = "60a076694ddc84953ed84eb335d1c98a";

/**
 * Algolia index names
 * Main index is sorted by most favorited
 * Replicas are used for additional sorting options
 * @todo move constants to `nvs-constants`
 * @see https://jira.nike.com/browse/NVS-2757
 */

/* Test indices */
const TEST_ALGOLIA_INDEX_NAME = "test-tokens"; // Default sorting should be by most favorited
const TEST_ALGOLIA_RECENTLY_CREATED_INDEX_NAME = "test-tokens_recently-created";

/* Production indices */
const PROD_ALGOLIA_INDEX_NAME = "tokens"; // Default sorting should be by most favorited
const PROD_ALGOLIA_RECENTLY_CREATED_INDEX_NAME = "tokens_recently-created";

const testAlgoliaIndexes = {
  main: TEST_ALGOLIA_INDEX_NAME,
  recentlyCreated: TEST_ALGOLIA_RECENTLY_CREATED_INDEX_NAME,
};

const prodAlgoliaIndexes = {
  main: PROD_ALGOLIA_INDEX_NAME,
  recentlyCreated: PROD_ALGOLIA_RECENTLY_CREATED_INDEX_NAME,
};

export const algoliaIndexNames = isProd()
  ? prodAlgoliaIndexes
  : testAlgoliaIndexes;
